import { render, staticRenderFns } from "./agreement_chatroom.vue?vue&type=template&id=12dfddf4&scoped=true&"
import script from "./agreement_chatroom.vue?vue&type=script&lang=js&"
export * from "./agreement_chatroom.vue?vue&type=script&lang=js&"
import style0 from "./agreement_chatroom.vue?vue&type=style&index=0&id=12dfddf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dfddf4",
  null
  
)

export default component.exports